/*
 * File: PatientChart.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 10/02/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Gets the information to be displayed in top of the chart and passes it to the classes to display it
 */
import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import CollapseHandler from "./CollapseHandler";
import CollapseCard from "./CollapseCard";
import UINotFound from "components/ui/UINotFound";
import UIProgress from "components/ui/UIProgress";
import ProviderOfficeFeeModel from "services/patients/demographics/provider_office_fee/store/ProviderOfficeFeeModel";
import PatientStore from "services/patients/store/PatientStore";
import { useStore } from "utils/useStore";
import { observer } from "mobx-react";

const PatientChart = () => {
  const patientStore = useStore(PatientStore);
  const providerOfficeModel = useStore(ProviderOfficeFeeModel);
  const [loading, setLoading] = useState(true);

  const getProviderModel = useCallback(async () => {
    setLoading(true);
    await providerOfficeModel.getProviderOfficeFeeData();
    setLoading(false);
  }, [providerOfficeModel]);

  useEffect(() => {
    getProviderModel();
  }, [getProviderModel]);

  if (loading) {
    return <UIProgress />;
  }
  if (!patientStore.patientModel.patientId) {
    return <UINotFound message="No patient was found" />;
  }
  return (
    <CollapseHandler>
      <CollapseCard
        patient={patientStore.patientModel}
        providerModel={providerOfficeModel}
      />
    </CollapseHandler>
  );
};

PatientChart.propTypes = {
  classes: PropTypes.object
};

export default observer(PatientChart);
